// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FPFa","newExpiryDate":"styles_newExpiryDate__6sPTY","footer":"styles_footer__2nCVb"};